import React from 'react';
import { HiBriefcase } from 'react-icons/hi';
import { HiCurrencyRupee, HiLocationMarker } from 'react-icons/hi';
import { PositionDocument } from 'types';

interface Props {
	position: PositionDocument;
}

const RecruiterPositionCardDetail = ({ position }: Props) => {
	const location = Array.isArray(position?.workLocations) ? position.workLocations.map(loc => loc.split(',')[0]) : [];
	// console.log('location', location);
	const locationArray = Array.isArray(location) ? location : location ? [location] : [];
	const workLocation = position?.workLocation;
	if (workLocation && !locationArray.includes(workLocation)) {
		locationArray.push(workLocation);
	}
	let locationArrayFiltered = locationArray;
	// console.log('locationArray', locationArray);
	if (locationArray.length > 1) {
		locationArrayFiltered = locationArray.filter(loc => loc.toLowerCase() !== 'any');
	}
	let locationString = Array.from(new Set(locationArrayFiltered.map(item => item.trim()).filter(item => item))).join(' | ');
	if (locationString.includes(',')) {
		locationString = locationString.replace(/,/g, " | ");
	}
    
	locationString = Array.from(new Set(locationString.split(" | ").map(item => item.toLowerCase())))
    .map(uniqueItem => locationString.split(" | ").find(item => item.toLowerCase() === uniqueItem))
    .join(" | ");

	// console.log('locationString', locationString);

	return (
		<>
			<div className="flex md:mb-2 sm:gap-x-4 mt-1 sm:gap-y-[6px] flex-col  md:gap-[6px]">
				<div className="flex flex-row gap-2 items-center">
					<div>
						<HiBriefcase className="text-[#00B7C4] dark:text-[#A9EFF2]" />
					</div>
					<div className="flex gap-1 items-center sm:text-[12px] text-[14px] text-[#28293D] dark:text-[#E4E4EB]">
						<div>{position.workingMode}</div>
						<div className="font-inter font-[500] text-[18px] leading-[16px] text-[#28293D] dark:text-[#C7C9D9]">•</div>
						{position.positionRequirement.workExperience?.min || position.positionRequirement.workExperience?.max ? (
							<>
								<div>
									{Math.floor(position.positionRequirement.workExperience?.min)} {'Yrs '}
									{Math.ceil(position.positionRequirement.workExperience?.min * 12) % 12} Mon -{' '}
									{Math.floor(position.positionRequirement.workExperience?.max)} {'Yrs '}
									{Math.ceil(position.positionRequirement.workExperience?.max * 12) % 12} Mon
								</div>
							</>
						) : (
							<div>Fresher</div>
						)}
					</div>
				</div>

				<div className="flex flex-row gap-2 items-center">
					<div>
						<HiCurrencyRupee className="text-[#00B7C4] dark:text-[#A9EFF2]" />
					</div>
					<div className="flex items-center sm:text-[12px] text-[14px] text-[#28293D] dark:text-[#E4E4EB]">
						{position.salary.min ?? 0} - {position.salary.max ?? 0} LPA
					</div>
				</div>

				<div className="flex flex-row gap-2 items-center">
					<div>
						<HiLocationMarker className="text-[#00B7C4] dark:text-[#A9EFF2]" />
					</div>
					<div className="flex gap-1 items-center sm:text-[12px] text-[14px] text-[#28293D] dark:text-[#E4E4EB]">
						{locationString !== position.positionType &&
							(
								<>
									<div>{locationString}</div>
									<div className="font-inter font-[500] text-[18px] leading-[16px] text-[#28293D] dark:text-[#C7C9D9]">•</div>
								</>)}
						<div>{position.positionType}</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default RecruiterPositionCardDetail;
